import { createTheme } from "@mui/material/styles";

const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0, // Extra small devices
      sm: 576, // Small devices (phones)
      md: 768, // Medium devices (tablets)
      lg: 992, // Large devices (desktops)
      xl: 1200, // Extra large devices
      xxl: 1400, // Extra extra large devices
    },
  },
  components: {
    MuiDateCalendar: {
      styleOverrides: {
        root: {
          direction: "ltr",
        },
      },
    },
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          direction: "ltr",
        },
      },
    },
  },
});

export default customTheme;
